<template>
<div>
    <v-btn fab color="primary" x-small v-if="eligible_user && !disable && !show && $route.name=='home' && submissions_flagged.length>0" style="z-index: 1000; position: fixed; top: 16px;" :style="{'left':'98px'}" @click="$emit('open')">
        <v-icon>mdi-bell-ring-outline</v-icon>
    </v-btn>

    <!-- WELCOME -->
    <v-dialog v-model="popups.welcome" :fullscreen="$vuetify.breakpoint.smAndDown" persistent max-width="1024">
        <v-card style="padding: 0px;">
            <v-card-text  style="padding: 0px;">
                

                <v-container fluid style="padding-top: 0px; padding-bottom: 0px;">

                    <v-row align="center" fill-height>
                        <v-col cols="12" v-if="!$vuetify.breakpoint.smAndDown" md="6" :style="{'background-image':'url('+images.picked+')'}" style="min-height: 550px; background-size: cover; background-color: #85A1D3;"/>

                        <v-col cols="12" md="6" style="padding: 25px;color: black;">
                            <h1 align='center' style="margin: 25px;">
                                <str index="pwc_recapture > welcome > title"/>
                            </h1>

                            <str index="pwc_recapture > welcome > body"/>


                            <div style="width: auto; text-align: center; margin-top: 80px;">
                                <v-btn color="primary" @click="popups.welcome = false;popups.recapture = true;">
                                    <str index="button > continue"/>
                                </v-btn>
                            </div>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" v-if="!$vuetify.breakpoint.smAndDown" md="6" style="background-color: #85A1D3;"/>

                        <v-col cols="12" md="6" style="margin: 0px; padding: 0px;">
                            <v-container flud>
                                <v-row no-gutters>
                                    <v-col cols="4" sm="4" md="4" style="padding: 0px; text-align: left;">
                                        <v-btn text @click="close" x-small>
                                            <str index="button > close"/>
                                        </v-btn>
                                    </v-col>

                                    <v-col cols="4" sm="4" md="4" style="padding: 0px; text-align: center;">
                                        <v-btn v-if="response && response.reminders.length>=2" text @click="remind_me_never" x-small >
                                            <str index="pwc_recapture > button > remind_me_never"/>
                                        </v-btn>
                                    </v-col>

                                    <v-col cols="4" sm="4" md="4" style="padding: 0px; text-align: right;">
                                        <v-btn text @click="remind_me" x-small >
                                            <str index="pwc_recapture > button > remind_me_3_days"/>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>


                        </v-col>
                    </v-row>
                </v-container>

            </v-card-text>
        </v-card>
    </v-dialog>

    <!-- RECAPTURE -->
    <v-dialog v-model="popups.recapture" :fullscreen="true" persistent>
        <v-card v-if="popups.recapture" :class="{[$style.mobile_margin]:$vuetify.breakpoint.smAndDown}" id="pwc_recapture_tool">
            <v-card-title/>
            <v-card-text style="min-height: 78vh; padding: 0px;">           

                <v-container>
                    <v-row>
                        <v-col cols="12" :md="mini ? 1 : 2" :class="{[$style.mobile_padding]:$vuetify.breakpoint.smAndDown}"/>
                        <v-col style="text-align: center;">
                            <img :src="images.logo"/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" :md="mini ? 1 : 2" :class="{[$style.mobile_padding]:$vuetify.breakpoint.smAndDown}">
                            <v-navigation-drawer
                                v-model="popups.drawer"
                                :mini-variant.sync="mini"
                                permanent
                                style="width: auto;"
                                >
                                <v-list-item class="px-2">
                                    <v-list-item-avatar>
                                        <v-img :src="images.logo_icon"></v-img>
                                    </v-list-item-avatar>

                                    <v-list-item-title>
                                        <str index="pwc_recapture > self_reflectives"/>
                                    </v-list-item-title>

                                    <v-btn
                                    v-if="!$vuetify.breakpoint.smAndDown"
                                    icon
                                    @click.stop="mini = !mini"
                                    >
                                    <v-icon>mdi-chevron-left</v-icon>
                                    </v-btn>
                                </v-list-item>

                                <v-divider></v-divider>

                                <v-list dense>
                                    <template v-for="(submission, submission_index) in submissions">
                                        <v-list-item v-show="submission.flagged" :key="'submission_'+submission_index" @click="submission_index!=submission_selection ? loadSubmission(submission_index) : false;" :class="[{[$style.submission_selector]:submission_index!=submission_selection},{[$style.selected]:submission_index==submission_selection}]">                                            
                                            <v-list-item-icon>
                                                <v-icon>mdi-note-text</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <span>
                                                    <span v-if="debug" style="color: red;">{{submission.id}} </span> 
                                                    <template v-if="$language=='fr'">
                                                        <span>{{questionMap[3].config.groups[0].inputs[submission.answers[3][1]-1].label[$language]}} de {{submission.answers[2][1][1]}} <str style="display:inline;" index="pwc_recapture > short_form > years_old"/> </span>
                                                    </template>
                                                    <template v-else>
                                                        <span style="text-transform: lowercase;">{{submission.answers[2][1][1]}} <str style="display:inline;" index="pwc_recapture > short_form > years_old"/> {{questionMap[3].config.groups[0].inputs[submission.answers[3][1]-1].label[$language]}}</span>
                                                    </template>
                                                </span>
                                            </v-list-item-content>
                                        </v-list-item>                                 
                                    </template>

                                    <v-list-item v-for="(submission, submission_id) in captured" :key="'captured_'+submission_id">
                                        <v-list-item-icon>
                                            <v-icon style="color: green; font-weight: bold;">mdi-check</v-icon>
                                        </v-list-item-icon>     
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <span>
                                                    <span v-if="debug" style="color: red;">{{submission_id}} => {{submission}} </span>                                            
                                                    <str index="pwc_recapture > received_thank_you"/>
                                                </span>
                                            </v-list-item-title>
                                        </v-list-item-content> 
                                    </v-list-item> 

                                    <v-divider></v-divider>

                                    <v-list-item>
                                        <v-btn color="#D2433F" x-small @click="close"><str index="button > close"/></v-btn>  
                                        <v-spacer/>
                                        <v-btn color="#85A1D3" x-small @click="goto_program">{{program.name[$language]}}</v-btn>  
                                    </v-list-item>


                                </v-list>
                                
                            </v-navigation-drawer>

                        </v-col>

                        <v-col cols="12" :md="mini ? 11 : 10" :class="{[$style.mobile_padding]:$vuetify.breakpoint.smAndDown}">

                            <template v-if="questions && answers">
                                <v-card>
                                    <v-card-title>
                                        <str index="pwc_recapture > profile"/>
                                    </v-card-title>
                                    <v-list>
                                        <template v-for="(question, question_index) in questions">
                                            <v-list-item v-if="in_array(question.config.id,[2,3,4,5,6,7,8,9,10,11,12,13,19,20,21]) && answers.answers[question.config.id][1]" :key="'question_'+question_index">
                                                <v-list-item-content>
                                                    <span v-html="question.config.body[$language]"/>
                                                    <br>
                                                    <div v-if="answers" style="font-weight: bold; margin-left: 25px;">
                                                        <template v-if="question.config.type=='Number'">
                                                            {{answers.answers[question.config.id][1][1]}}
                                                        </template>
                                                        <template v-else-if="question.config.type=='Radio'">
                                                            <span v-html="questionMap[question.config.id].config.groups[0].inputs[answers.answers[question.config.id][1]-1].label[$language]"/>
                                                        </template>
                                                        <template v-else>
                                                            <span v-for="(selection, selection_index) in answers.answers[question.config.id][1]" :key="question.config.id+'_'+selection">
                                                                {{questionMap[question.config.id].config.groups[0].inputs[selection-1].label[$language]}}
                                                                <br v-if="selection_index<answers.answers[question.config.id][1].length-1"/>
                                                            </span>
                                                        </template>
                                                    </div>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-list>
                                </v-card>

                                <template>
                                    <Survey 
                                        :item = "item"
                                        :program = "program"
                                        :showAllQuestionsToggleInItems = "false"
                                        :enablePaginationToggleInItems = "false"
                                        :adminModeSelectionInItems = "'live'"
                                        :submission_record="answers"
                                        @survey_submission="survey_submission"
                                    />
                                </template>                            
                            </template>

                            <template v-else-if="submissions_flagged.length==0 && captured">
                                <h3 align='center' style="margin-top: 100px;">
                                    <str index="pwc_recapture > all done"/>
                                        <br>
                                    <v-btn color="#D2433F" x-small @click="close"><str index="pwc_recapture > return_home"/></v-btn>  
                                </h3>
                            </template>

                            <template v-else>
                                <str index="pwc_recapture > start_message"/>
                            </template>
                        </v-col>
                    </v-row>
                </v-container>
                
            </v-card-text>

            <v-card-actions v-if="$store.getters.mode=='test'">
                <v-switch 
                    v-model="debug"
                    :true-value="true"
                    :false-value="false"
                    label="Debug"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.display">
        <str v-if="snackbar.message" :index="snackbar.message"/>
    </v-snackbar>

</div>
</template>

<script>
import { Machine, interpret} from 'xstate'; //assign, sendParent, spawn, raise, actions, send, respond
import Survey from '@/components/Survey/Survey.vue';
import logo_en from './assets/logo_en.png';
import logo_fr from './assets/logo_fr.png';
import logo_icon from './assets/logo_icon.png';
import picked from './assets/picked.jpg';

export default {
    props: {
        myprograms: {
            type: Array,
            required: true
        },
        show: {
            type: Boolean,
            required: true
        }
    },
    components: {
        Survey
    },
    created: function(){
        let component = this;  

        const dataHandler = new function(){

            this.fetch = new function(){

                this.submissions = function(){
                    return new Promise((resolve, reject)=>{
                        if(component.sendRequest){
                            let action = 'pwc_recap';
                            let call = 'fetch_submissions';
                            component.sendRequest({
                                action: action,
                                call: call,
                                data: {
                                    user_id: component.user_id,
                                    program_id: component.program_id,
                                    survey_id: component.survey_id,
                                    role: 'user'
                                }
                            }).then(function(response){
                                component.response = response.data[action][call]
                                component.logs = component.response.logs;
                                let records = response.data[action][call].submissions.results;
                                let submissions = [];
                                for(let s=0; s<records.length; s++){
                                    let submission = component.parseJSON(records[s]);
                                    submission.flagged = component.flag_submission(submission.answers);
                                    submissions.push(submission);
                                }
                                component.submissions = submissions;
                                component.survey = component.parseJSON(response.data[action][call].questions.results[0]);
                                resolve();
                            },function(){
                                reject();
                            })

                        }else{
                            setTimeout(function(){
                                resolve();
                            },1000)
                        }
                    })
                }

            }

            this.save = new function(){

                this.new_submission = function(){
                    return new Promise((resolve, reject)=>{
                        if(component.sendRequest){
                            let action = 'pwc_recap';
                            let call = 'new_submission';
                            component.sendRequest({
                                action: action,
                                call: call,
                                data: {
                                    user_id: component.user_id,
                                    program_id: component.program_id,
                                    survey_id: component.survey_id,
                                    target_submission: component.submissions[component.submission_selection].id,
                                    new_submission: component.new_submission.submission_id
                                }
                            }).then(function(response){
                                resolve();
                            },function(){
                                reject();
                            })

                        }else{
                            setTimeout(function(){
                                resolve();
                            },1000)
                        }
                    })
                }


                this.remind_me = function(never=false){

                    return new Promise((resolve, reject)=>{
                        if(component.sendRequest){
                            let action = 'pwc_recap';
                            let call = never ? 'remind_me_never' : 'remind_me';
                            component.sendRequest({
                                action: action,
                                call: call,
                                data: {
                                    user_id: component.user_id,
                                    program_id: component.program_id,
                                    survey_id: component.survey_id,
                                    project: 'pwc_recap'
                                }
                            }).then(function(response){
                                resolve();
                            },function(){
                                reject();
                            })

                        }else{
                            setTimeout(function(){
                                resolve();
                            },1000)
                        }
                    })

                }
            }

        }
        
        let machineConfig = {
            id: 'app',
            context: {
                error: null
            },
            type: 'parallel',
            states: {
                fetch: {
                    id: 'fetch',
                    type: 'parallel',
                    states: {
                        submissions: {
                            initial: 'ready',
                            states: {
                                ready: {
                                    on: {
                                        'fetch.submissions': 'active'
                                    }                                    
                                },
                                active: {
                                    invoke: {
                                        src: () => new Promise((resolve, reject)=>{
                                            dataHandler.fetch.submissions(component).then(function(){
                                                resolve();
                                            },function(){
                                                reject();
                                            })
                                        }),
                                        onDone: {
                                            target: 'ready'
                                        }
                                    }

                                }
                            }
                        }
                    }
                },
                save: {
                    id: 'save',
                    type: 'parallel',
                    states: {
                        new_submission: {
                            initial: 'ready',
                            states: {
                                ready: {
                                    on: {
                                        'save.new_submission': 'active'
                                    }                                    
                                },
                                active: {
                                    invoke: {
                                        src: () => new Promise((resolve, reject)=>{
                                            dataHandler.save.new_submission(component).then(function(){
                                                component.unloadSubmission();
                                                component.snackbar.display = true;
                                                component.snackbar.message = 'pwc_recapture > received_thank_you'
                                                resolve();
                                            },function(){
                                                reject();
                                            })
                                        }),
                                        onDone: {
                                            target: ['ready','#fetch.submissions.active']
                                        }
                                    }

                                }
                            }
                        },
                        remind_me: {
                            initial: 'ready',
                            states: {
                                ready: {
                                    on: {
                                        'save.remind_me': 'active'
                                    }                                    
                                },
                                active: {
                                    invoke: {
                                        src: () => new Promise((resolve, reject)=>{
                                            dataHandler.save.remind_me(false).then(function(){
                                                component.$emit('close')
                                                resolve();
                                            },function(){
                                                reject();
                                            })
                                        }),
                                        onDone: {
                                            target: ['ready']
                                        }
                                    }

                                }
                            }
                        },
                        remind_me_never: {
                            initial: 'ready',
                            states: {
                                ready: {
                                    on: {
                                        'save.remind_me_never': 'active'
                                    }                                    
                                },
                                active: {
                                    invoke: {
                                        src: () => new Promise((resolve, reject)=>{
                                            dataHandler.save.remind_me(true).then(function(){
                                                component.$emit('close')
                                                resolve();
                                            },function(){
                                                reject();
                                            })
                                        }),
                                        onDone: {
                                            target: ['ready']
                                        }
                                    }

                                }
                            }
                        }
                    }
                }
            }
        }

        const machine = Machine(machineConfig,{
            guards: {
                allow_comms: function(context){
                    return (component && component.$store) ? component.$store.getters.csrf!=null : context.csrf.value!=null;
                },
                allow_login: function(context){
                    return (component && component.$store) ? component.$store.getters.jwt===null : context.jwt.value===null;
                },
                allow_logout: function(context){
                    return (component && component.$store) ? component.$store.getters.jwt!=null : context.jwt.value!=null;
                }
            }
        });


        this.service = interpret(machine)
        this.state = machine.initialState
        this.context = machine.context

        var self = this
        self.service.onTransition(state => {
            self.state = state.value;
            self.context = state.context
        }).start();

        this.init();
    },
    data: function(){
        return {
            debug: false,
            service: null,
            context: null,
            state: null,
            mini: false,
            popups: {
                recapture: false,
                welcome: false,
                drawer: false
            },
            snackbar: {
                display: false,
                message: null
            },
            response: null,
            new_submission: null,
            submissions: [],
            logs: [],
            survey: null,
            submission_selection: null,
            program_id: 12,
            survey_id: 8,
            flow_index: 3,
            item_index: 0
        }
    },
    methods: {
        init: function(){

            if(this.show && !this.popups.recapture){
                this.popups.welcome = true;
            }

            if(this.eligible_user){
                this.service.send('fetch.submissions')
            }


            if(this.eligible_user && !this.disable && this.reminder.triggered && this.submissions_flagged.length>0){
                this.$emit('open');
            }            
        },
        remind_me: function(){
            this.service.send('save.remind_me');
        },
        remind_me_never: function(){
            this.service.send('save.remind_me_never');
            this.response.remind_me_never.push('disable')
        },
        close: function(){
            this.$emit('close');
        },
        goto_program: function(){
            let self = this;
            self.close();
            self.$router.push('/program/user/'+self.program.id+'/');
        },
        loadSubmission: function(submission_index){
            let self = this;
            self.submission_selection = null;
            setTimeout(function(){
                self.submission_selection = submission_index;
            },200)
        },
        unloadSubmission: function(){
            let self = this;
            setTimeout(function(){
                self.submission_selection = null;
            },200)
        },
        survey_submission: function(data){
            this.new_submission = data.submission;
            this.service.send('save.new_submission')
        },
        flag_submission: function(answers){
            let a1c_target = parseFloat(answers[9][1][1],10);
            let a1c_current = parseFloat(answers[10][1][1],10);
            let q_14 = answers[14][1];
            let flag = a1c_current>a1c_target && q_14==null;
            
            return flag;
        }
    },
    computed: {
        $language: function(){
            return this.$store.getters.language;
        },
        images: function(){
            return {
                logo: this.$language=='fr' ? logo_fr : logo_en,
                picked: picked,
                logo_icon: logo_icon
            }
        },
        user_id: function(){
            return this.$store.getters.user.id;
        },
        submissions_flagged: function(){
            let flagged = [];
            let submissions = this.submissions;
            for(let i=0; i<submissions.length; i++){
                if(submissions[i].flagged){
                    flagged.push(submissions[i]);
                }
            }
            return flagged;
        },
        answers: function(){
            return this.submission_selection!=null ? {
                answers:this.submissions[this.submission_selection].answers, 
                others:this.submissions[this.submission_selection].others, 
                logs:this.submissions[this.submission_selection].logs, 
                prompts:this.submissions[this.submission_selection].prompts, 
                widgets:this.submissions[this.submission_selection].widgets
                } : null;
        },
        questions: function(){
            return this.survey ? this.survey.data.questions : null;
        },
        questionMap: function(){
            let questionMap = {};
            let questions = this.questions;
            for(let i=0; i<questions.length; i++){
                let question = questions[i];
                questionMap[question.config.id] = question;
            }
            return questionMap;
        },
        program: function(){
            let program = this.$controller.program.programMap()[this.program_id] ? this.unlink(this.$controller.program.programMap()[this.program_id]) : null;
            if(program){
                program.role = 'user';
            }
            return program;
        },
        item: function(){
            return this.program.flow[this.flow_index].items[this.item_index];
        },
        captured: function(){
            let results = {};
            let logs = this.logs;
            for(let i=0; i<logs.length; i++){
                let log = logs[i].parameters;
                results[log.target_submission] = log.new_submission
            }
            return results;
        },
        eligible_user: function(){
            let myprograms = this.myprograms;
            let program_id = this.program_id;
            for(let i=0; i<myprograms.length; i++){
                let myprogram = myprograms[i].program;
                if(myprogram.id==program_id && this.program.state=='live'){
                    return true;
                }
            }
            
            return false;
        },
        reminder: function(){
            let response = this.response;
            let timestamp = response && (response.reminders && response.reminders[0]) ? response.reminders[0].timestamp.replace(' ','T') : null;
            let reminder = null;
            let now = new Date();
            if(timestamp){
                reminder = new Date(timestamp);
                reminder.setDate(reminder.getDate()+3);
                let trigger_date = reminder.getFullYear()+'-'+(reminder.getMonth()+1)+'-'+reminder.getDate();
                reminder = new Date(trigger_date)
            }
            let result = {
                triggered: reminder===null || (now >= reminder),
                timestamp: timestamp,
                now: now,
                date: reminder
            }
            return result;
        },
        disable: function(){
            let response = this.response;

            return response && response.remind_me_never.length>0;
        }
    },
    watch: {
        show: function(){
            this.popups.welcome = this.show===true;
            if(!this.show){
                this.popups.recapture = false;
                this.unloadSubmission();
            }
        },
        eligible_user: function(){
            this.init();
        },
        reminder: function(){
            this.init();
        },
        myprograms: function(){
            this.init();
        }
    }
}
</script>

<style module>
.submission_selector{
    cursor: pointer;
    transition: all 0.4;
}
    .submission_selector:hover{
        background-color: whitesmoke;
        font-weight: bold;
        color: black;
    }
.selected{
    font-weight: bold;
    background-color: slategrey;
    color: white;
}

.mobile_margin{
    margin: 0;
}
.mobile_padding{
    padding: 0px;
}
</style>